<script lang="ts" setup>
const props = withDefaults(
    defineProps<{
        autoFallback?: boolean;
        src: string;
        alt?: string;
        size?:
            | "sm"
            | "3xs"
            | "2xs"
            | "xs"
            | "md"
            | "lg"
            | "xl"
            | "2xl"
            | "3xl"
            | "none";
        uiAvatarOptions?: Parameters<typeof createUiAvatar>[0];
    }>(),
    {
        uiAvatarOptions: () => ({}),
        autoFallback: false,
        size: "2xs",
        alt: undefined,
    },
);

const innerSrc = computed(() => {
    if (props.autoFallback && !props.src) {
        return createUiAvatar({
            name: props.alt ?? "-",
            ...props.uiAvatarOptions,
        });
    }

    return props.src;
});
</script>

<template>
    <img
        :alt="alt"
        :class="{
            'h-4 max-w-[1rem]': size === '3xs',
            'h-5 max-w-[1.25rem]': size === '2xs',
            'h-6 max-w-[1.5rem]': size === 'xs',
            'h-8 max-w-[2rem]': size === 'sm',
            'h-10 max-w-[2.5rem]': size === 'md',
            'h-12 max-w-[3rem]': size === 'lg',
            'h-14 max-w-[3.5rem]': size === 'xl',
            'h-16 max-w-[4rem]': size === '2xl',
            'h-20 max-w-[5rem]': size === '3xl',
        }"
        :src="innerSrc"
        class="object-contain"
    />
</template>
